// extracted by mini-css-extract-plugin
module.exports = {"documentsGrid":"styles_documentsGrid__2xcF1"};